<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d" />
  </svg>
</template>

<script setup>
/**
 * Pictogramme trait des barres de navigation v2 : grille 24, un tracé ou
 * plusieurs, trait 1,8 par défaut.
 *
 * Extrait de la barre du back-office quand les espaces portail en ont eu
 * besoin à leur tour (canvas « Barre de navigation des portails »).
 * Remplace Font Awesome dans les barres uniquement — le reste de l'app garde
 * ses <i class="fas"> tant que les parcours ne sont pas refondus.
 */
defineProps({
  paths: { type: Array, required: true },
  size: { type: [Number, String], default: 20 },
  strokeWidth: { type: [Number, String], default: 1.8 }
})
</script>

<style scoped>
svg {
  display: block;
  flex-shrink: 0;
}
</style>
